export enum IcIcon {
  App = 'app',
  Apple = 'apple',
  ArrowDown = 'arrow-down',
  ArrowLeft = 'arrow-left',
  ArrowNext = 'arrow-next',
  ArrowPrev = 'arrow-prev',
  ArrowRight = 'arrow-right',
  ArrowUp = 'arrow-up',
  Artists = 'artists',
  AudioRound = 'audio-round',
  AudioSimple = 'audio-simple',
  Broadcast = 'broadcast',
  Checkmark = 'checkmark',
  CloseThin = 'close-thin',
  Collections = 'collections',
  Competition = 'competition',
  Discover = 'discover',
  Dots = 'dots',
  Facebook = 'facebook',
  FavoriteOff = 'favorite-off',
  FavoriteOn = 'favorite-on',
  Fryderyk = 'fryderyk',
  Fullscreen = 'fullscreen',
  Google = 'google',
  HamburgerDefault = 'hamburger-default',
  HamburgerTracklist = 'hamburger-tracklist',
  Info = 'info',
  Live = 'live',
  LockedLarge = 'locked-large',
  LockedNormal = 'locked-normal',
  Loop_1 = 'loop-1',
  Loop = 'loop',
  Off = 'off',
  Password = 'password',
  Pause = 'pause',
  Play = 'play',
  PlaylistAdd = 'playlist-add',
  PlaylistRound = 'playlist-round',
  Plus = 'plus',
  Radio = 'radio',
  Random = 'random',
  Search = 'search',
  Search2 = 'search2',
  Settings = 'settings',
  Share = 'share',
  SocialFacebook = 'social-facebook',
  SocialTwitter = 'social-twitter',
  SocialYoutube = 'social-youtube',
  SortDesc = 'sort-desc',
  Sound = 'sound',
  Subscription = 'subscription',
  Tone = 'tone',
  User = 'user',
  VideoHeader = 'video-header',
  VideoMediaType = 'video-media-type',
  VideoRound = 'video-round',
  VideoVideo = 'video-video',
}
